var RESET_PARENT_HTML_ATTRIBUTE = "consent-cb-reset-parent";
var RESET_PARENT_HTML_ATTRIBUTE_VALUE = "1";
var KNOWN_RATIO_CLASSES = {
  // Elementor
  asSuffix: "-fit-aspect-ratio",
  // Gutenberg
  gutenberg: "wp-block-embed__wrapper",
  // Cornerstone
  cornerstone: "x-frame-inner"
};
/**
 * In some cases it is necessary to reset some styles which are not resettable through
 * the `style` attribute. E.g. pseudo-classes like `::before` and `::after`.
 */

function applyContentBlockRatioCssPlainCss() {
  var element = document.createElement("style");
  element.style.type = "text/css";
  document.getElementsByTagName("head")[0].appendChild(element);
  var attribute = "".concat(RESET_PARENT_HTML_ATTRIBUTE, "=\"").concat(RESET_PARENT_HTML_ATTRIBUTE_VALUE, "\"");
  var rules = []; // Gutenberg

  rules.push(".wp-block-embed__wrapper[".concat(attribute, "]::before{padding-top:0!important;}")); // Thrive Architect

  rules.push(".thrv_wrapper[".concat(attribute, "]::before{display:none!important;}"));
  rules.push(".tve_responsive_video_container[".concat(attribute, "]{padding-bottom:0!important;}")); // JetElements for Elementor

  rules.push(".jet-video[".concat(attribute, "]{background:none!important;}"));
  rules.push(".jet-video[".concat(attribute, "]>.jet-video__overlay{display:none!important;}")); // Divi Page Builder

  rules.push(".et_pb_video[".concat(attribute, "]>.et_pb_video_overlay{display:none!important;}"));
  element.innerHTML = rules.join("");
}

export { applyContentBlockRatioCssPlainCss, RESET_PARENT_HTML_ATTRIBUTE, RESET_PARENT_HTML_ATTRIBUTE_VALUE, KNOWN_RATIO_CLASSES };